<script lang="ts" setup>
import type { Props } from './types'

defineProps<Props>()

</script>

<script lang="ts">
export default {
  name: 'OnboardingStepsIndicator'
}
</script>

<template>
  <div class="flex justify-center mb-24">
    <div
      class="onboarding-step-indicator-arrow"
      :class="{ 'bg-lavender-600': step === 1, 'bg-gray2-400': step !== 1 }" />

    <div
      class="onboarding-step-indicator-arrow"
      :class="{ 'bg-lavender-600': step === 2, 'bg-gray2-400': step !== 2 }" />

    <div
      class="onboarding-step-indicator-arrow"
      :class="{ 'bg-lavender-600': step === 3, 'bg-gray2-400': step !== 3 }" />
  </div>
</template>

<style>
.onboarding-step-indicator-arrow {
  width: 50px;
  height: 40px;
  margin-left: -5px;
  clip-path: polygon(75% 0%, 100% 50%, 75% 100%, 0% 100%, 25% 50%, 0% 0%);
}
</style>
